<template>
    <v-container>

        <!-- <div>
            <p>{{$t("LP.contents.summary")}}</p>
        </div> -->

        <v-row class="mt-10">

            <!-- S1 Prologue コンテンツ -->
            <v-col cols="12" sm="6" md="4">
                <v-card max-width="100%" class="mx-auto" dark>
                    <v-img :aspect-ratio="15.9235/10" min-height="200px" :src="$t('LP.contents1.image')"></v-img>
                    <div class="pa-5">
                        <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                        <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                            {{$t("LP.contents1.title")}}</p>
                        <p class="text-caption" align="left">
                            {{$t('LP.contents1.caption') | omittedText}}
                        </p>
                    </div>
                    <!-- <v-card-actions>
                        <v-btn text @click="reveal1 = true">
                            {{$t('LP.contents1.more')}}
                        </v-btn>
                    </v-card-actions> -->

                    <!-- さらに詳しく -->
                    <v-expand-transition>
                        <v-card v-if="reveal1" class="transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
                            <v-img :aspect-ratio="15.9235/10" height="100px" :src="$t('LP.contents1.image')">
                            </v-img>
                            <div class="pa-5">
                                <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                                <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                                    {{$t('LP.contents1.title')}}</p>
                                <p class="text-caption" align="left">
                                    {{$t('LP.contents1.more_text')}}
                                </p>
                            </div>
                            <v-card-actions class="pt-0">
                                <v-btn text @click="reveal1 = false">
                                    {{$t('LP.contents1.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-expand-transition>
                </v-card>
            </v-col>

            <!-- S2 Future City コンテンツ -->
            <v-col cols="12" sm="6" md="4">
                <v-card max-width="100%" class="mx-auto" dark>
                    <v-img :aspect-ratio="15.9235/10" min-height="200px" :src="$t('LP.contents2.image')"></v-img>
                    <div class="pa-5">
                        <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                        <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                            {{$t("LP.contents2.title")}}</p>
                        <p class="text-caption" align="left">
                            {{$t('LP.contents2.caption') | omittedText}}
                        </p>
                    </div>
                    <!-- <v-card-actions>
                        <v-btn text @click="reveal2 = true">
                            {{$t('LP.contents2.more')}}
                        </v-btn>
                    </v-card-actions> -->

                    <!-- さらに詳しく -->
                    <v-expand-transition>
                        <v-card v-if="reveal2" class="transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
                            <v-img :aspect-ratio="15.9235/10" height="100px" :src="$t('LP.contents2.image')">
                            </v-img>
                            <div class="pa-5">
                                <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                                <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                                    {{$t('LP.contents2.title')}}</p>
                                <p class="text-caption" align="left">
                                    {{$t('LP.contents2.more_text')}}
                                </p>
                            </div>
                            <v-card-actions class="pt-0">
                                <v-btn text @click="reveal2 = false">
                                    {{$t('LP.contents2.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-expand-transition>
                </v-card>
            </v-col>

            <!-- S3 Future Park コンテンツ -->
            <v-col cols="12" sm="6" md="4">
                <v-card max-width="100%" class="mx-auto" dark>
                    <v-img :aspect-ratio="15.9235/10" min-height="200px" :src="$t('LP.contents3.image')"></v-img>
                    <div class="pa-5">
                        <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                        <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                            {{$t("LP.contents3.title")}}</p>
                        <p class="text-caption" align="left">
                            {{$t('LP.contents3.caption') | omittedText}}
                        </p>
                    </div>
                    <!-- <v-card-actions>
                        <v-btn text @click="reveal3 = true">
                            {{$t('LP.contents3.more')}}
                        </v-btn>
                    </v-card-actions> -->

                    <!-- さらに詳しく -->
                    <v-expand-transition>
                        <v-card v-if="reveal3" class="transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
                            <v-img :aspect-ratio="15.9235/10" height="100px" :src="$t('LP.contents3.image')">
                            </v-img>
                            <div class="pa-5">
                                <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                                <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                                    {{$t('LP.contents3.title')}}</p>
                                <p class="text-caption" align="left">
                                    {{$t('LP.contents3.more_text')}}
                                </p>
                            </div>
                            <v-card-actions class="pt-0">
                                <v-btn text @click="reveal3 = false">
                                    {{$t('LP.contents3.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-expand-transition>
                </v-card>
            </v-col>

            <!-- S4 Ocean Workd コンテンツ -->
            <v-col cols="12" sm="6" md="4">
                <v-card max-width="100%" class="mx-auto" dark>
                    <v-img :aspect-ratio="15.9235/10" min-height="200px" :src="$t('LP.contents4.image')"></v-img>
                    <div class="pa-5">
                        <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                        <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                            {{$t("LP.contents4.title")}}</p>
                        <p class="text-caption" align="left">
                            {{$t('LP.contents4.caption') | omittedText}}
                        </p>
                    </div>
                    <!-- <v-card-actions>
                        <v-btn text @click="reveal4 = true">
                            {{$t('LP.contents4.more')}}
                        </v-btn>
                    </v-card-actions> -->

                    <!-- さらに詳しく -->
                    <v-expand-transition>
                        <v-card v-if="reveal4" class="transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
                            <v-img :aspect-ratio="15.9235/10" height="100px" :src="$t('LP.contents4.image')">
                            </v-img>
                            <div class="pa-5">
                                <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                                <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                                    {{$t('LP.contents4.title')}}</p>
                                <p class="text-caption" align="left">
                                    {{$t('LP.contents4.more_text')}}
                                </p>
                            </div>
                            <v-card-actions class="pt-0">
                                <v-btn text @click="reveal4 = false">
                                    {{$t('LP.contents4.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-expand-transition>
                </v-card>
            </v-col>

            <!-- S5 Augmented World コンテンツ -->
            <v-col cols="12" sm="6" md="4">
                <v-card max-width="100%" class="mx-auto" dark>
                    <v-img :aspect-ratio="15.9235/10" min-height="200px" :src="$t('LP.contents5.image')"></v-img>
                    <div class="pa-5">
                        <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                        <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                            {{$t("LP.contents5.title")}}</p>
                        <p class="text-caption" align="left">
                            {{$t('LP.contents5.caption') | omittedText}}
                        </p>
                    </div>
                    <!-- <v-card-actions>
                        <v-btn text @click="reveal5 = true">
                            {{$t('LP.contents5.more')}}
                        </v-btn>
                    </v-card-actions> -->

                    <!-- さらに詳しく -->
                    <v-expand-transition>
                        <v-card v-if="reveal5" class="transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
                            <v-img :aspect-ratio="15.9235/10" height="100px" :src="$t('LP.contents5.image')">
                            </v-img>
                            <div class="pa-5">
                                <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                                <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                                    {{$t('LP.contents5.title')}}</p>
                                <p class="text-caption" align="left">
                                    {{$t('LP.contents5.more_text')}}
                                </p>
                            </div>
                            <v-card-actions class="pt-0">
                                <v-btn text @click="reveal5 = false">
                                    {{$t('LP.contents5.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-expand-transition>
                </v-card>
            </v-col>

            <!-- S6 Epilogue コンテンツ -->
            <v-col cols="12" sm="6" md="4">
                <v-card max-width="100%" class="mx-auto" dark>
                    <v-img :aspect-ratio="15.9235/10" min-height="200px" :src="$t('LP.contents6.image')"></v-img>
                    <div class="pa-5">
                        <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                        <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                            {{$t("LP.contents6.title")}}</p>
                        <p class="text-caption" align="left">
                            {{$t('LP.contents6.caption') | omittedText}}
                        </p>
                    </div>
                    <!-- <v-card-actions>
                        <v-btn text @click="reveal6 = true">
                            {{$t('LP.contents6.more')}}
                        </v-btn>
                    </v-card-actions> -->

                    <!-- さらに詳しく -->
                    <v-expand-transition>
                        <v-card v-if="reveal6" class="transition-fast-in-fast-out v-card--reveal" style="height: 100%;">
                            <v-img :aspect-ratio="15.9235/10" height="100px" :src="$t('LP.contents6.image')">
                            </v-img>
                            <div class="pa-5">
                                <!--<p class="text-caption mb-1"><small>{{$t('LP.contents1.title_sub')}}</small></p>-->
                                <p class="text-body-1 font-weight-bold" style="line-height:1.2em;">
                                    {{$t('LP.contents6.title')}}</p>
                                <p class="text-caption" align="left">
                                    {{$t('LP.contents6.more_text')}}
                                </p>
                            </div>
                            <v-card-actions class="pt-0">
                                <v-btn text @click="reveal6 = false">
                                    {{$t('LP.contents6.close')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-expand-transition>
                </v-card>
            </v-col>



            <div class="swiper-pagination" slot="pagination"></div>
        </v-row>

    </v-container>
</template>


<script>
    export default {

        data() {
            return {
                reveal1: false,
                reveal2: false,
                reveal3: false,
                reveal4: false,
                reveal5: false,
                reveal6: false,
            }
        },


        //カードの文字数制御
        filters: {
            omittedText(text) {
                // 11文字目以降は"…"
                return text.length > 60 ? text.slice(0, 60) + "…" : text;
            },
            omittedText20(text) {
                // 21文字目以降は"…"
                return text.length > 20 ? text.slice(0, 20) + "…" : text;
            }
        },

    }
</script>

<style lang="scss" scoped>
    .v-card {
        height: 100%;
        background: #0066BE;
    }

    .v-card--reveal {
        bottom: 0;
        opacity: 1 !important;
        position: absolute;
        width: 100%;
    }

    .theme--dark.v-card{
        background: #0066BE!important;
    }
</style>